import React from 'react';

export type LegendSectionItem = { label: string; color: string };

export default function LegendSection({
  title,
  items,
  isConnectors = false,
}: Readonly<{
  title: string;
  items: LegendSectionItem[];
  isConnectors?: boolean;
}>) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        padding: '0 16px',
        borderRight: '1px solid #e5e7eb',
      }}
    >
      <span style={{ fontSize: '11px', fontWeight: 600, color: '#4b5563' }}>{title}</span>
      <div
        style={{
          display: 'flex',
          gap: '12px',
          alignItems: 'center',
          flexWrap: 'wrap',
        }}
      >
        {items.map((item) => (
          <div key={item.label} style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            {isConnectors ? (
              <div
                style={{
                  width: '16px',
                  height: '2px',
                  background: item.color,
                  borderRadius: '1px',
                }}
              />
            ) : (
              <div
                style={{
                  width: '12px',
                  height: '12px',
                  background: item.color,
                  borderRadius: '2px',
                }}
              />
            )}
            <span style={{ fontSize: '10px', color: '#6b7280', whiteSpace: 'nowrap' }}>
              {item.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
